import { gql } from "@apollo/client";

export const FIND_STRATEGY_FACILITY_BY_STRATEGY = gql`
  query FindStrategyFacilityByStrategy($uuid: ID!) {
    findStrategyFacilityByStrategy(uuid: $uuid) {
      summary
      uuid
    }
  }
`;

export const UPDATE_STRATEGY_FACILITY = gql`
  mutation UpdateStrategyFacility($data: UpdateStrategyFacilityInput!) {
    updateStrategyFacility(data: $data) {
      summary
      uuid
    }
  }
`;

export const FIND_ALL_FACILITIES_BY_STRATEGY_FACILITY = gql`
  query FindAllFacilitiesByStrategyFacility($uuid: ID!) {
    findAllFacilitiesByStrategyFacility(uuid: $uuid) {
      adequate
      available
      contactFirstName
      contactLastName
      cost
      email
      name
      rampUpTime
      uuid
    }
  }
`;

export const CREATE_FACILITY = gql`
  mutation Facility($data: CreateFacilityInput!) {
    createFacility(data: $data) {
      adequate
      available
      contactFirstName
      contactLastName
      cost
      email
      name
      rampUpTime
      uuid
    }
  }
`;

export const UPDATE_FACILITY = gql`
  mutation Facility($data: UpdateFacilityInput!) {
    updateFacility(data: $data) {
      adequate
      available
      contactFirstName
      contactLastName
      cost
      email
      name
      rampUpTime
      uuid
    }
  }
`;

export const DELETE_FACILITY = gql`
  mutation DeleteFacility($uuid: ID!) {
    deleteFacility(uuid: $uuid) {
      adequate
      available
      contactFirstName
      contactLastName
      cost
      email
      name
      rampUpTime
      uuid
    }
  }
`;
